<div class="p-booking-info-mdl__item-head p-booking-info-mdl__item-head--pb8">
  <span
    class="p-booking-info-mdl__item-head-title"
    style="display: flex; align-items: center; justify-content: space-between"
  >
    <span [innerHTML]="parts.passengerNameHeader"></span>

    <span
      *ngIf="parts.registrarionLabel !== ''"
      class="p-booking-info-mdl__open-state p-booking-info-mdl__open-state--editing u-after-image-none"
      style="font-weight: normal"
      [innerHTML]="parts.registrarionLabel | staticMsg"
    ></span>
  </span>
  <span
    *ngIf="parts.passengerTypeLabel !== ''"
    class="p-booking-info-mdl__open-subtext"
    [innerHTML]="parts.passengerTypeLabel | staticMsg"
  >
  </span>
</div>
